import { ERegisterType } from 'api/public';
import { setUserToken, setUserId, setScheduleToken } from 'utils/localstore';
import { setCurrentPlatformType } from 'utils/sessionStorage';

/**
 * 用户认证成功后的通用处理函数
 * 用于统一处理登录和注册成功后的用户数据设置
 * 注意：此函数需要在组件内部调用，因为它需要ProviderStore的set函数
 *
 * @param setProviderData - ProviderStore的set函数
 * @param authPayload - 认证载荷数据
 * @param token - 用户令牌
 * @param platformType - 平台类型，默认为 KLARITY_PORTAL
 */
export const handleAuthSuccess = (
    setProviderData: (key: 'data', value: any) => void,
    authPayload: any,
    token: string,
    platformType: ERegisterType = ERegisterType.KLARITY_PORTAL,
) => {
    // 设置Provider Store数据
    setProviderData('data', {
        ...authPayload,
        email: authPayload?.email,
        id: authPayload?.id,
    });

    // 设置用户ID到localStorage
    setUserId(authPayload?.id);

    // 设置用户令牌到localStorage
    setUserToken(token);
    setScheduleToken(token);

    // 设置当前平台类型到sessionStorage
    setCurrentPlatformType(platformType);
    console.log('platformType: ', platformType);
};

export const handleSwitchSuccess = (
    setProviderData: (key: 'data', value: any) => void,
    authPayload: any,
    token: string,
) => {
    // 设置Provider Store数据
    setProviderData('data', {
        ...authPayload,
        email: authPayload?.email,
        id: authPayload?.id,
    });

    // 设置用户ID到localStorage
    setUserId(authPayload?.id);

    // 设置用户令牌到localStorage
    setUserToken(token);
    setScheduleToken(token);
};

/**
 * 处理注册和登录API响应的通用函数
 * 用于统一处理API返回的数据结构
 *
 * @param result - API响应结果
 * @param setProviderData - ProviderStore的set函数
 * @param platformType - 平台类型，默认为 KLARITY_PORTAL
 * @returns 处理后的认证数据，如果失败返回null
 */
export const processAuthResponse = (
    result: any,
    setProviderData: (key: 'data', value: any) => void,
    platformType: ERegisterType = ERegisterType.KLARITY_PORTAL,
) => {
    if (!result.error && result.data?.data) {
        const { authPaylod, token } = result.data.data;

        if (authPaylod && token) {
            handleAuthSuccess(setProviderData, authPaylod, token, platformType);
            return { authPayload: authPaylod, token };
        }
    }

    return null;
};
